import '../CsvJsonInfoPages.scss';


function TechnicalDataChanges() {

    const data = [
        { field: 1, description: 'CAP ID Number (Int)' },
        { field: 2, description: 'Technical Data Dictionary Code (Int) – From NVDDictionaryTechnical' },
        { field: 3, description: 'Date When Technical Data Changed (Date, yyyy/mm/dd)' },
    ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Technical Data Changes</h1>
            <p>This file contains vehicles information regarding date changes to technical information. <br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDChanges_Technical.txt<br />
                LIGHTS_yyyy-mm-dd_ NVDChanges_Technical.txt<br />
                HEAVIES_yyyy-mm-dd_ NVDChanges_Technical.txt<br />
                BIKES_yyyy-mm-dd_ NVDChanges_Technical.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default TechnicalDataChanges;
